export default "/static/byonoy_tiny.png";